import React, { useState } from "react";
import { apiClient } from "../../App";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Slider } from "../ui/slider";

export function ContractKpiCard({ kpi, contractId, onUpdate }) {
  const [pct, setPct] = useState(kpi.completion_pct ?? 0);
  const [saving, setSaving] = useState(false);
  const debounceRef = React.useRef(null);

  const handlePctChange = (values) => {
    const newPct = values[0];
    setPct(newPct);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      setSaving(true);
      try {
        await apiClient.put(`/contracts/${contractId}/contract-kpis/${kpi.id}?completion_pct=${newPct}`);
        onUpdate();
      } catch (e) {
        toast.error("Failed to save completion");
      } finally {
        setSaving(false);
      }
    }, 600);
  };

  const pctColor = pct >= 80 ? "text-emerald-600" : pct >= 50 ? "text-amber-600" : "text-red-600";
  const barColor = pct >= 80 ? "bg-emerald-500" : pct >= 50 ? "bg-amber-500" : "bg-red-500";

  return (
    <div className="p-3 border rounded-sm space-y-2" data-testid={`contract-kpi-${kpi.id}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium">{kpi.description}</p>
          {kpi.measure && <p className="text-xs text-slate-500 mt-0.5">Measure: {kpi.measure}</p>}
          {kpi.delivery_date && <p className="text-xs text-slate-400">Due: {kpi.delivery_date}</p>}
        </div>
        <span className={`text-lg font-bold tabular-nums ${pctColor}`}>{pct}%</span>
      </div>
      <div className="flex items-center gap-3">
        <Slider
          value={[pct]}
          onValueChange={handlePctChange}
          max={100}
          step={5}
          className="flex-1"
          data-testid={`kpi-slider-${kpi.id}`}
        />
        {saving && <Loader2 size={14} className="animate-spin text-slate-400" />}
      </div>
      <div className="w-full bg-slate-100 dark:bg-slate-800 rounded-full h-1.5">
        <div className={`h-1.5 rounded-full transition-all ${barColor}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
